export const billingConfiguration = {
  header: {
    title: "إعدادات الفوترة",
    description:
      "أدِر مُصدِري الفوترة في حسابك واربط كل إقامة بالمُصدِر المناسب.",
  },

  intro: {
    lead:
      "<strong>مُصدِر الفوترة</strong> هو الكيان الضريبي الذي يُصدر الفواتير لنزلائك. يمكنك امتلاك عدة مُصدِرين واختيار من يُصدر فواتير كل إقامة.",
    feats: {
      fiscalData: {
        label: "بيانات ضريبية خاصة",
        tip: "الاسم القانوني وNIF/CIF والعنوان الضريبي التي تظهر في الفاتورة.",
      },
      series: {
        label: "سلسلة مستقلة",
        tip: "لكل مُصدِر سلسلته وتسلسله الخاص (وكذلك لإشعارات الدائن) دون اختلاط.",
      },
      verifactu: {
        label: "VeriFactu لكل مُصدِر",
        tip: "يستوفي كل مُصدِر متطلبات VeriFactu (التوقيع والتسجيل لدى AEAT) بشكل منفصل وفق إعداداته الضريبية.",
      },
      assignment: {
        label: "التعيين لكل إقامة",
        tip: "اربط كل إقامة بمُصدِر. تستخدم الإقامات غير المعيّنة المُصدِر الرئيسي.",
      },
    },
    foot: "عند الإصدار، يُستخدم مُصدِر الإقامة الخاصة بالحجز (عند تسجيل المغادرة أو عندما يطلبها النزيل من وكيل الذكاء الاصطناعي).",
  },

  issuers: {
    card: {
      title: "مُصدِرو الفوترة",
      subtitle: "أنشئ عدة مُصدِرين وعيّن إقاماتك لكل منهم.",
    },
    searchPlaceholder: "ابحث عن مُصدِر بالاسم أو NIF…",
    newButton: "مُصدِر جديد",
    noName: "بلا اسم",
    defaultBadge: "رئيسي",
    listingsCount: "{count} إقامة",
    empty: {
      noMatch: "لا يوجد مُصدِر يطابق البحث.",
      none: "لا يوجد لديك مُصدِرون بعد. أنشئ الأول عبر ”مُصدِر جديد“.",
    },
  },

  assign: {
    card: {
      title: "تعيين الإقامات",
      subtitle:
        "اختر المُصدِر الذي يُصدر فواتير كل إقامة. لا يمكن أن يكون للإقامة سوى مُصدِر واحد؛ وتستخدم غير المعيّنة المُصدِر الرئيسي.",
    },
    searchPlaceholder: "ابحث عن إقامة…",
    filter: {
      all: "الكل",
      unassigned: "غير معيَّن",
    },
    issuerFallback: "المُصدِر #{id}",
    principalSuffix: " (رئيسي)",
    unassignedOption: "— غير معيَّن (رئيسي)",
    empty: {
      noMatch: "لا توجد إقامة تطابق عامل التصفية.",
      none: "لا توجد لديك إقامات بعد.",
    },
    count: "{shown} من {total} إقامة",
  },

  drawer: {
    editTitle: "تعديل المُصدِر",
    newTitle: "مُصدِر جديد",
    subtitle: "البيانات الضريبية لمُصدِر الفوترة",
    closeAria: "إغلاق",
    footer: {
      isDefault: "هو الرئيسي",
      setDefault: "تعيين كرئيسي",
      delete: "حذف",
      cancel: "إلغاء",
      saving: "جارٍ الحفظ…",
      save: "حفظ المُصدِر",
    },
  },

  company: {
    title: "بيانات الشركة",
    subtitle: "المعلومات الضريبية لعقارك",
    country: {
      label: "بلد الفوترة",
      hint: "اختر البلد الضريبي الذي ينطبق على هذه الإعدادات.",
    },
    personType: {
      label: "نوع الكيان",
      company: "كيان اعتباري (شركة)",
      individual: "شخص طبيعي (عامل مستقل)",
    },
    legalName: {
      label: "الاسم / الاسم القانوني",
      placeholderCompany: "مثال: INNDEV S.L.",
      placeholderIndividual: "مثال: ماريا غارثيا",
      hint: "الاسم الضريبي للشركة أو الشخص",
    },
    co: {
      regime: {
        label: "نظام DIAN",
        common: "النظام العام",
        simplified: "النظام المبسّط",
        hint: "إلزامي للفوترة الإلكترونية لدى DIAN",
      },
      municipality: {
        label: "بلدية DIAN",
        hint: "رمز DIVIPOLA لبلديتك — إلزامي لدى DIAN.",
        selected: "المحدَّد: {code}",
      },
      responsibilities: {
        label: "المسؤوليات الضريبية",
        placeholder: "مثال: O-13, R-99-PN",
        hint: "رموز مفصولة بفواصل. الأكثر شيوعًا: <strong>O-13</strong>",
      },
    },
    mx: {
      regime: {
        label: "النظام الضريبي (SAT)",
        placeholder: "مثال: 601",
        hint: "رمز النظام الضريبي SAT",
      },
      zip: {
        label: "الرمز البريدي الضريبي (SAT)",
        placeholder: "مثال: 06600",
        hint: "الرمز البريدي الضريبي SAT",
      },
    },
  },

  address: {
    title: "العنوان الضريبي",
    subtitle: "العنوان الذي يظهر في الفواتير",
    street: {
      label: "الشارع والرقم",
    },
    city: {
      label: "المدينة",
      hint: "المدينة والرمز البريدي",
    },
    email: {
      label: "البريد الإلكتروني للفوترة",
      placeholder: "billing@yourproperty.com",
    },
    phone: {
      label: "الهاتف",
    },
    ph: {
      ES: {
        street: "مثال: شارع غران فيا 42، الطابق 3",
        city: "مدريد",
        zip: "28001",
        regionLabel: "المقاطعة",
        region: "مدريد",
        phone: "+34 123 456 789",
      },
      CO: {
        street: "مثال: كالي 13 رقم 10-25",
        city: "بوغوتا",
        zip: "110111",
        regionLabel: "الإدارة",
        region: "كونديناماركا",
        phone: "+57 601 234 5678",
      },
      MX: {
        street: "مثال: شارع إنسورخنتيس سور 1234",
        city: "مدينة مكسيكو",
        zip: "06600",
        regionLabel: "الولاية",
        region: "CDMX",
        phone: "+52 55 1234 5678",
      },
    },
  },

  bank: {
    title: "حساب التحصيل",
    subtitle: "إلى أين يُحوَّل لك المال عند الدفع بحوالة بنكية",
    iban: {
      label: "رقم الحساب (IBAN)",
      placeholder: "ES91 2100 0418 4502 0005 1332",
      hint: "يظهر في الفاتورة فقط عندما تكون طريقة الدفع حوالة بنكية.",
      error: "رقم الحساب (IBAN) غير صالح.",
    },
    bic: {
      label: "BIC / SWIFT",
      placeholder: "CAIXESBB",
      hint: "اختياري. مطلوب للتحصيل من خارج منطقة SEPA.",
    },
    holder: {
      label: "صاحب الحساب",
      placeholder: "اتركه فارغًا إذا كان مطابقًا للاسم القانوني",
      hint: "فقط إذا كان الحساب باسم مختلف عن اسم الشركة.",
    },
  },

  invoice: {
    title: "إعدادات الفاتورة",
    subtitle: "تنسيق مستنداتك وعملتها وترقيمها",
    currency: {
      label: "العملة الافتراضية",
      hint: "العملة التي ستصدر بها الفواتير",
    },
    taxRate: {
      label: "نسبة IVA الافتراضية %",
      hintCO: "IVA العام كولومبيا: <strong>19%</strong>",
      hintMX: "IVA العام المكسيك: <strong>16%</strong>",
      hintES: "IVA المخفَّض للضيافة إسبانيا: <strong>10%</strong> — العام: <strong>21%</strong>",
    },
    type: {
      label: "نوع الفاتورة",
      detailed: {
        label: "مفصّل",
        desc: "كل خدمة في سطر مستقل",
      },
      simplified: {
        label: "مبسّط",
        desc: "إيصال أو فاتورة ببنود مجمّعة",
      },
    },
    numbering: {
      label: "ترقيم المستندات",
      example: "مثال: {value}",
      invoices: {
        title: "الفواتير",
      },
      series: "السلسلة",
      optional: "(اختياري)",
      optionalPlaceholder: "اختياري",
      digits: "الأرقام",
      nextNumber: "الرقم التالي",
      hintOptional: "السلسلة اختيارية. إذا تركتها فارغة، ستصدر الفاتورة بالرقم التسلسلي فقط.",
      hintFormat: "إذا حدّدت سلسلة، سيُنشئ النظام الرمز بصيغة SERIES-NUMBER. وبدون سلسلة، سيُنشئ NUMBER فقط.",
      hintWarn: "اضبط هذه القيمة قبل إصدار أول فاتورة في السلسلة للحفاظ على تسلسل ضريبي متوافق.",
      hintSandboxCO: "في بيئة الاختبار استخدم <strong>SETP</strong> — وفي بيئة الإنتاج يجب أن يطابق قرار DIAN الخاص بك.",
    },
    creditNotes: {
      title: "إشعارات دائنة",
      badge: "إلغاءات / تصحيحات",
      hint: "تُستخدم لإشعار الدائن أو الإلغاء التالي الذي تصدره.",
    },
    footer: {
      label: "التذييل الافتراضي",
      hint: "النص الذي سيظهر أسفل جميع الفواتير",
      phES: "مثال: عملية خاضعة لضريبة IVA المخفَّضة للضيافة وفق المادة 91 من قانون IVA",
      phCO: "مثال: قرار DIAN رقم 000123 بتاريخ 01-01-2025. النطاقات من 1 إلى 5000000",
      phMX: "مثال: فاتورة CFDI صادرة وفق متطلبات المادة 29-A من قانون CFF",
    },
  },

  advanced: {
    title: "خيارات متقدمة",
    subtitle: "إعدادات إرسال إضافية",
    attachPdf: {
      label: "إرفاق PDF",
      text: "تضمين مستند PDF إلى جانب رابط التنزيل",
    },
  },

  loading: {
    default: "جارٍ التحميل…",
    config: "جارٍ تحميل الإعدادات…",
    profiles: "جارٍ تحميل المُصدِرين…",
    saving: "جارٍ حفظ الإعدادات…",
  },

  countries: {
    ES: "إسبانيا",
    CO: "كولومبيا",
    MX: "المكسيك",
  },

  currencies: {
    EUR: "يورو",
    COP: "بيزو كولومبي",
    USD: "دولار أمريكي",
    MXN: "بيزو مكسيكي",
  },

  taxId: {
    labelFallback: "المعرّف الضريبي",
    helpES: "NIF للأفراد وCIF للشركات. مثال: B12345678",
    helpCO: "NIT مع رقم التحقق. مثال: 9014514812 (10 أرقام)",
    helpMX: "RFC مكوّن من 12 أو 13 حرفًا. مثال: XAXX010101000",
    helpFallback: "المعرّف الضريبي",
  },

  validation: {
    taxIdES: "تنسيق غير صالح. مثال: B12345678",
    taxIdCO: "يجب أن يتكوّن NIT من 9 أو 10 أرقام. مثال: 9014514812",
    taxIdMX: "تنسيق RFC غير صالح. مثال: XAXX010101000",
  },

  msg: {
    reassignError: "تعذّرت إعادة تعيين الإقامة.",
    defaultUpdated: "تم تحديث المُصدِر الرئيسي.",
    setDefaultError: "تعذّر التعيين كمُصدِر رئيسي.",
    deleteConfirm: "هل تريد حذف مُصدِر الفوترة هذا؟",
    deleted: "تم حذف المُصدِر.",
    deleteError: "تعذّر حذف المُصدِر.",
    requiredFields: "أكمل جميع الحقول المطلوبة قبل الحفظ.",
    fixTaxId: "صحّح المعرّف الضريبي قبل الحفظ.",
    coRegimeRequired: "نظام DIAN مطلوب لكولومبيا.",
    coMunicipalityRequired: "بلدية DIAN مطلوبة لكولومبيا.",
    savedOk: "تم حفظ المُصدِر بنجاح.",
    saveError: "حدث خطأ أثناء حفظ الإعدادات.",
  },

  misc: {
    thisIssuer: "هذا المُصدِر",
  },
};
